import { Dispatch } from '@reduxjs/toolkit';
import { AnyAction } from 'redux-saga';
import { zooluxCallCenterAPI } from '../../../zooluxCallCenterAPI';

const userAPI = zooluxCallCenterAPI.injectEndpoints({
    endpoints: (builder) => ({
        getAccessToAccount: builder.mutation<any, any>({
            query: ({ id }) => { 
                return {
                    url: `/user-auth/come-in-user/${id}`,
                    method: 'POST',
                };
            },
            async onQueryStarted(_, { dispatch, queryFulfilled }: {
                dispatch: Dispatch<AnyAction>,
                queryFulfilled: Promise<{ data: any; }>,
            }) {
                try { } catch (error) {
                    console.error("Error fetching getAccessToUser:", error);
                }
            },
            invalidatesTags: ["UserAdmin"]
        }),
    }),
    overrideExisting: false,
});

export const { useGetAccessToAccountMutation } = userAPI;
